import React from 'react';
import LoadingSpinner from './LoadingSpinner';

function PageLoader({ label = 'Loading Onahiri…' }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 bg-zinc-50">
      <LoadingSpinner size="large" />
      <p className="text-sm text-zinc-500">{label}</p>
    </div>
  );
}

export default PageLoader;
